import { toast } from "react-toastify";
import moment from "moment-jalaali";
import * as timezone from "moment-timezone";
export function formatBytes(bytes: number, decimals = 2) {
  if (!+bytes) return "0 Bytes";

  const k = 1024;
  const dm = decimals < 0 ? 0 : decimals;
  const sizes = ["Bytes", "Kb", "Mb", "Gb", "Tb"];

  const i = Math.floor(Math.log(bytes) / Math.log(k));

  return `${parseFloat((bytes / Math.pow(k, i)).toFixed(dm))} ${sizes[i]}`;
}

export function isImage(url) {
  return /\.(jpg|jpeg|png|webp|avif|gif|svg)$/.test(url);
}

export const runToast = (
  message: string,
  type: "success" | "error",
  options?: any
) => {
  if (type === "success") {
    toast.success(message, { position: "top-center", ...options });
  }
  if (type === "error") {
    toast.error(message, { position: "top-center", ...options });
  }
};

export const formatRiTTo = (numericString) => {
  const numericValue = +numericString / 10;

  if (!isNaN(numericValue)) {
    return numericValue.toLocaleString();
  } else {
    console.error("Invalid numeric string format");
    return numericString;
  }
};

// Helper function to format date
// export const formatDate = (dateString, formatString = 'jYYYY/jMM/jDD | HH:mm:ss') => {
export const formatDate = (dateString, formatString = "jYYYY/jMM/jDD ") => {
  const jDate = moment(dateString, "YYYY-M-DTH:m:s.SZ");
  return jDate.format(formatString);
};

// export const formatRiTTo=(rial:string|number)=>{
//   return (+rial/10).toLocaleString()
// }

export const convertSDate = (isoDate: any) => {
  if (isoDate) {
    isoDate = timezone.tz(isoDate, "Asia/Tehran");
    moment.locale("fa"); // Set the locale to Farsi
    let momentObject = moment(isoDate);
    const jalaliYear = moment(isoDate).format("jYYYY");
    const jalaliDay = moment(isoDate).format("jD");
    const monthName = moment(isoDate).format("jMM");
    const hours = momentObject.format("HH");
    const minutes = momentObject.format("mm");
    const seconds = momentObject.format("ss");
    return `${jalaliYear}/${monthName}/${jalaliDay}  `;
  }
};
export const convertDateAndTime = (isoDate: any) => {
  if (isoDate) {
    isoDate = timezone.tz(isoDate, "Asia/Tehran");
    moment.locale("fa"); // Set the locale to Farsi
    let momentObject = moment(isoDate);
    const jalaliYear = moment(isoDate).format("jYYYY");
    const jalaliDay = moment(isoDate).format("jD");
    const monthName = moment(isoDate).format("jMM");
    const hours = momentObject.format("HH");
    const minutes = momentObject.format("mm");
    const seconds = momentObject.format("ss");
    return `${hours}:${minutes}:${seconds}  |   ${jalaliYear}/${monthName}/${jalaliDay}  `;
  }
};
export const convertPDate = (isoDate: any) => {
  if (isoDate) {
    isoDate = timezone.tz(isoDate, "Asia/Tehran");
    moment.locale("fa"); // Set the locale to Farsi
    let momentObject = moment(isoDate);
    const jalaliYear = moment(isoDate).format("jYYYY");
    const jalaliDay = moment(isoDate).format("jD");
    const monthName = moment(isoDate).format("jMM");
    return `  ${jalaliYear}/${monthName}/${jalaliDay}  `;
  }
};
export const calendarDateFormat = (isoDate: any) => {
  if (isoDate) {
    isoDate = timezone.tz(isoDate, "Asia/Tehran");
    moment.locale("fa"); // Set the locale to Farsi
    let momentObject = moment(isoDate);
    const jalaliYear = moment(isoDate).format("jYYYY");
    const jalaliDay = moment(isoDate).format("jD");
    const monthName = moment(isoDate).format("jMM");
    return {
      year: Number(jalaliYear),
      month: Number(monthName),
      day: Number(jalaliDay),
    };
  }
};

export function calculateAge(birthDateString) {
  const birthDate = new Date(birthDateString);
  const currentDate = new Date();

  let age = currentDate.getFullYear() - birthDate.getFullYear();

  // Check if the birthday has passed this year
  if (
    currentDate.getMonth() < birthDate.getMonth() ||
    (currentDate.getMonth() === birthDate.getMonth() &&
      currentDate.getDate() < birthDate.getDate())
  ) {
    age--;
  }

  return age;
}

export function sleep(delay) {
  return new Promise((resolve) => setTimeout(resolve, delay));
}

export function convertShamsiToMiladi(persianDate: any) {
  const globalDate = moment(
    `${persianDate.year}/${persianDate.month}/${persianDate.day}`,
    "jYYYY/jM/jD"
  ).format("YYYY-MM-DD");
  return globalDate;
}
